import { firestore } from "@/services/firebase.provider";
import { isCurrentEnvProduction } from "@/utils/env.utils";

class SiteRepositoryStrategy {
  constructor() {}

  static create() {
    return isCurrentEnvProduction()
      ? new FirebaseSiteRepositoryStrategy()
      : new MockSiteRepositoryStrategy();
  }

  findAll() {}
}

class MockSiteRepositoryStrategy extends SiteRepositoryStrategy {
  constructor() {
    super();
    this.FILE_NAME = "./data.json";
  }

  findAll() {
    return require(`${this.FILE_NAME}`);
  }
}
class FirebaseSiteRepositoryStrategy extends SiteRepositoryStrategy {
  constructor() {
    super();
    this.COLLECTION_NAME = "crush";
  }

  async findAll() {
    const collection = await firestore
      .collection(`${this.COLLECTION_NAME}`)
      .get();

    return collection.docs.map(document => document.data());
  }
}

export {
  SiteRepositoryStrategy as default,
  MockSiteRepositoryStrategy,
  FirebaseSiteRepositoryStrategy
};
